import { get, post, postForm } from "./request.js";
import qs from "qs";

// 直播节目，PGC音视频（声音广州+本地资讯+粤韵风情）
export function showProgramDetailIntroByType(params) {
  return post("/hcfm-cloud-manage-app/site/rest/pgc/voiceGZ/showProgramDetailIntroByType", params);
}

// 根据专辑id批量查询该专辑的主持人列表
export function queryAnchorDetialsByColunmId(params) {
  return post("/hcfm-cloud-manage-app/site/rest/anchor/queryAnchorDetialsByColunmId", params);
}

// PGC专辑评分---平均分
export function queryColumnsAverageScore(params) {
  return post("/hcfm-cloud-interact-app/site/rest/grade/queryAvgGrade", params);
}

// 查询当前专辑在本一级分类的排名
export function queryColumnRankInCategory(params) {
  return post("/hcfm-cloud-manage-app/site/rest/pgc/columns/queryColumnRankInCategory", params);
}

// 节目详情-往期节目
export function queryHistoryProgramByName(params) {
  return post("/hcfm-cloud-manage-app/site/rest/pgc/voiceGZ/queryHistoryProgramByName", params);
}

// 获取当前频道直播节目
export function selectCurrentLivingProgramByCode(params) {
  return get(
    "/hcfm-cloud-manage-app/site/rest/index/selectCurrentLivingProgramByCode",
    params
  );
}

// 查询当前节目的主持人列表
export function getProgramHostInfos(params) {
  return post("/hcfm-cloud-manage-app/site/rest/community/getProgramHostInfos", params)
    .then(res => res)
    .catch(e => e);
}

// 根据条件查询频道和正在直播的节目信息
export function queryRadioStationAndProgram(params = {}) {
  return post("/hcfm-cloud-manage-app/site/rest/index/queryRadioStationAndProgram", params);
}

// 查询当前节目的N日回听接口
export function getProgramReplayInfos(params) {
  return post("/hcfm-cloud-manage-app/site/rest/community/getProgramReplayInfos", params)
    .then(res => res)
    .catch(e => e);
}

// 通过radio_code查询直播节目信息
export function queryRadioStationAndProgramByCode(params) {
  return get(
    "/hcfm-cloud-manage-app/site/rest/index/queryRadioStationAndProgramByCode",
    params
  )
    .then(res => res)
    .catch(e => e);
}

// 查询完整节目单
export function queryAllProgramMenuPool(params) {
  return post("/hcfm-cloud-manage-app/site/rest/radio/queryAllProgramMenuPool", params)
    .then(res => res)
    .catch(e => e);
}

// 加载当前正在播放节目单及当天剩下时间的所有节目单
export function queryProgramMenuPoolCurrentAndLeft(params) {
  return post("/hcfm-cloud-manage-app/site/rest/index/pool/queryProgramMenuPoolCurrentAndLeft", params)
    .then(res => res)
    .catch(e => e);
}

// 查询更多热门主播 按照频率分组
export function popularHostsTopAllByRadio(params) {
  return post("/hcfm-cloud-manage-app/site/rest/anchor/popularHostsTopAllByRadio", params)
    .then(res => res)
    .catch(e => e);
}

// 获取特定频道更多热门节目清单
export function popularProgramAllMoreByRadio(params) {
  return post("/hcfm-cloud-manage-app/site/rest/popular/popularProgramAllMoreByRadio", params)
    .then(res => res)
    .catch(e => e);
}

// 主播》》主播详情页面用户信息
export function queryAnchorDetails(params) {
  return post("/hcfm-cloud-manage-app/site/rest/anchor/queryAnchorDetails", params)
    .then(res => res)
    .catch(e => e);
}

// 查询主播（个人）的鲜花榜前N位以及总收到花数
export function queryPersonFlowersTopRank(params) {
  return post("/hcfm-cloud-manage-app/site/rest/hcfm/flower/queryPersonFlowersTopRank", params)
    .then(res => res)
    .catch(e => e);
}

// 获取主持人节目列表
export function selectProgramByHostUserId(params) {
  return get("/hcfm-cloud-manage-app/site/rest/popular/selectProgramByHostUserId", params)
    .then(res => res)
    .catch(e => e);
}

// 查询当前主播专辑
export function queryAnchorSpecials(params) {
  return get("/hcfm-cloud-manage-app/site/rest/anchor/queryAnchorSpecials", params)
    .then(res => res)
    .catch(e => e);
}

// 查询当前用户收到的评论列表，按照评论时间降序排序---需用户登录
export function queryPersonMessageByPage(params) {
  return post("/hcfm-cloud-interact-app/site/rest/message/queryPersonMessageByPage", params)
    .then(res => res)
    .catch(e => e);
}

// 首页-花城头条-更多
export function queryAllTopNewsListByPage(params) {
  return post("/hcfm-cloud-manage-app/site/rest/hcfm/topNews/queryAllTopNewsListByPage", params)
    .then(res => res)
    .catch(e => e);
}

// 查询专题详情（点击量、分享数）
export function querySpecialDetail(params) {
  return post("/hcfm-cloud-manage-app/site/rest/hcfm/special/queryFCspecialById", params)
    .then(res => res)
    .catch(e => e);
}

// 查询专题详情列表（根据specialId获取）
export function queryFCspecialDetailsBySpecialId(params) {
  return post("/hcfm-cloud-manage-app/site/rest/hcfm/special/queryFCspecialDetailsBySpecialId", params)
    .then(res => res)
    .catch(e => e);
}

// 根据活动id，加载活动详情页。
export function queryActivityDetials(params) {
  return postForm("/hcfm-cloud-interact-app/site/rest/activity/queryActivityDetials", qs.stringify(params))
    .then(res => res)
    .catch(e => e);
}

// 活动详情页面，分页加载投稿作品
export function selectVoteRank(params) {
  return post("/hcfm-cloud-interact-app/site/rest/activity/selectVoteRank", params)
    .then(res => res)
    .catch(e => e);
}

// 根据专辑ID获取所有节目id
export function queryAllIdByColumnsId(params) {
  return post("/hcfm-cloud-manage-app/site/rest/pgc/voiceGZ/queryColumnAvList", params)
    .then(res => res)
    .catch(e => e);
}

// 加载评论及子评论(返回的结果中二级评论及以下的评论均嵌套在一级评论下，不做无限嵌套)，结果会根据用户的实际权限查出待审核的评论，一共后续操作
export function queryCommentWithoutStatusByPage(params) {
  return post("/hcfm-cloud-interact-app/site/rest/comments/queryCommentWithoutStatusByPage", params)
    .then(res => res)
    .catch(e => e);
}

// 根据ID查询节目详情
export function selectProgramById(params) {
  return get("/hcfm-cloud-manage-app/site/rest/index/selectProgramById", params)
    .then(res => res)
    .catch(e => e);
}

// 根据id查询直播间详情
export function queryLivingRoomDetails(params) {
  return post("/hcfm-cloud-interact-app/site/rest/liveRoom/queryLivingRoomDetails", params)
    .then(res => res)
    .catch(e => e);
}

// 查询直播间信息
export function queryLivingByOperation(params) {
  return post("/hcfm-cloud-interact-app/site/rest/liveRoom/queryLivingByOperation", params)
    .then(res => res)
    .catch(e => e);
}

// 获取稿件详情
export function getHcfmArticle(id) {
  return get(`/gzbn-cloud-manuscript-app/app/article/hcfmDetail/${id}`, params)
    .then(res => res)
    .catch(e => e);
}
